import { format } from "@react-input/mask";
import React, { useEffect, useState, useCallback } from "react";
import { fetchAddressByCep } from "../Fetch/FetchAddress";
import { MaskedInput } from "./MaskedInput";


interface Props {
  value: string;
  idCnpj?:any;
  isInvalid?: Record<string, boolean>;
  setIsInvalid?: any;
  setCustomerData?: (data: any) => void;
  customerData?: {
    cep: string;
    endereco?: string;
    bairro?: string;
    cidade?: string;
    estado?: string;
    [key: string]: any;
  };
}

const InputCep: React.FC<Props> = ({ value, idCnpj,setCustomerData, isInvalid, setIsInvalid, customerData }) => {
  const [maskedValue, setMaskedValue] = useState(value);
  const [valueClean, setValueClean] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    const { id, value } = event.target;
    const cleanValue = value.replace(/\D/g, "");

    setValueClean(cleanValue);

    setCustomerData?.((prevForm: any) => ({
      ...prevForm,
      [id]: cleanValue,
    }));

    setIsInvalid?.((prevForm: any) => ({
      ...prevForm,
      [id]: false,
    }));

    setMaskedValue(value);
  }, [setCustomerData, setIsInvalid]);

  const handleBlur = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    const { id } = event.target;
    if (valueClean.length < 8) {
      setIsInvalid?.((prevForm: any) => ({
        ...prevForm,
        [id]: true,
      }));
    }
  }, [valueClean, setIsInvalid]);

  const fetchAddress = async (cep: string) => {
    try {
      setIsLoading(true);
      const addressData = await fetchAddressByCep(cep);
      if (addressData) {
        setCustomerData?.({ ...customerData, ...addressData || '' });
        setIsInvalid?.((prevForm: any) => ({
          ...prevForm, endereco: false, bairro:false, cidade:false, estado:false
        }));
      }
    } catch (error) {
      console.error("Erro ao buscar endereço:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!maskedValue) {
      setMaskedValue(format(value, { mask: "_____-___", replacement: { _: /\d/ } }));
      setValueClean(value)

    }

    if (valueClean.length === 8) {
      fetchAddress(valueClean);
    }
  }, [valueClean, value]);

  return (
    <div className="col-md-3">
      <label>CEP</label>
      <MaskedInput
        id="cep"
        idCnpj={idCnpj}
        value={maskedValue}
        onChange={handleChange}
        onBlur={handleBlur}
        mask="_____-___"
        isInvalid={isInvalid?.cep}
        placeholder="00000-000"
      />
      {isInvalid?.cep && <p className="invalid-feedback">Insira um CEP válido</p>}
      {isLoading && <p>Carregando endereço...</p>}
    </div>
  );
};

export default InputCep;
